import { normalizeImageUrl } from '../../utils/utils';
import './simpleManyPhotoContainer.css';

interface SimplePhotoItemProps {
  title: string;
  img: string | null;
  alt?: string;
}

function SimplePhotoItem({ title, img, alt = title }: SimplePhotoItemProps) {
  const placeholderImage = '/images/profile.png';
  const imageSrc = normalizeImageUrl(img);

  return (
    <div className="simple-photo-item">
      <div className="simple-photo-image">
        <img
          src={imageSrc}
          alt={alt}
          onError={(e) => {
            e.currentTarget.src = placeholderImage;
          }}
        />
      </div>
      <div className="simple-photo-title">{title}</div>
    </div>
  );
}

interface ICarPhotosData {
  frontPhoto?: string | null;
  backPhoto?: string | null;
  leftPhoto?: string | null;
  rightPhoto?: string | null;
  trunkPhoto?: string | null;
}

interface SimpleManyPhotoContainerProps {
  carPhotos: ICarPhotosData;
  title?: string;
  showTitle?: boolean;
}

function SimpleManyPhotoContainer({ carPhotos, title = 'Фото авто', showTitle = true }: SimpleManyPhotoContainerProps) {
  // Проверяем, есть ли хотя бы одно фото
  const hasAnyPhoto =
    carPhotos.frontPhoto || carPhotos.backPhoto || carPhotos.leftPhoto || carPhotos.rightPhoto || carPhotos.trunkPhoto;

  if (!hasAnyPhoto) {
    return (
      <div className="simple-photo-container">
        {showTitle && <div className="simple-photo-header">{title}</div>}
        <div className="no-photos-message">Фотографии отсутствуют</div>
      </div>
    );
  }

  return (
    <div className="simple-photo-container">
      {showTitle && <div className="simple-photo-header">{title}</div>}
      <div className="simple-photo-grid">
        {carPhotos.frontPhoto && <SimplePhotoItem title="Спереди" img={carPhotos.frontPhoto} />}
        {carPhotos.rightPhoto && <SimplePhotoItem title="Правый бок" img={carPhotos.rightPhoto} />}
        {carPhotos.backPhoto && <SimplePhotoItem title="Вид сзади" img={carPhotos.backPhoto} />}
        {carPhotos.leftPhoto && <SimplePhotoItem title="Левый бок" img={carPhotos.leftPhoto} />}
        {carPhotos.trunkPhoto && <SimplePhotoItem title="Фото багажника" img={carPhotos.trunkPhoto} />}
      </div>
    </div>
  );
}

export default SimpleManyPhotoContainer;
